export const roleOptions = [
    { label: 'CXO', value: 'CXO' },
    { label: 'VP', value: 'VP' },
    { label: 'Director', value: 'Director' },
    { label: 'Manager', value: 'Manager' },
    { label: 'Contributor', value: 'Contributor' }
  ];
  
  export const companySizeOptions = [
    { label: '1-15', value: '1-15' },
    { label: '16-100', value: '16-100' },
    { label: '101-500', value: '101-500' },
    { label: '501-1000', value: '501-1000' },
    { label: '1001+', value: '1001+' }
  ];
  
  export const salesHelpOptions = [
    { label: 'want_to_evaluate_cloud_archive', value: 'want_to_evaluate_cloud_archive' },
    { label: 'want_to_understand_cloud_archive', value: 'want_to_understand_cloud_archive' },
    { label: 'want_to_buy_licenses', value: 'want_to_buy_licenses' },
    { label: 'have_product_question', value: 'have_product_question' },
    { label: 'need_compliance_plan', value: 'need_compliance_plan' }
  ];
  